import { TextField } from '@mui/material';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({}) => ({}));

export default StyledTextField;
